<ng-container *transloco="let t">
    <div
        *ngIf="placeholderListKey"
        class="bazis-item bazis-item_placeholder"
    >
        {{ t(placeholderListKey) }}
    </div>
    <ng-container *ngIf="!placeholderListKey">
        <div
            *ngIf="emptyListKey && !list?.length && !loadingList"
            class="bazis-item bazis-item_placeholder"
        >
            {{ t(emptyListKey) }}
        </div>

        <div
            *ngIf="loadingList && loadingListKey && updatingListKey"
            class="bazis-item bazis-item_placeholder"
        >
            {{ list?.length ? t(updatingListKey) : t(loadingListKey) }}
        </div>
    </ng-container>
    <div
        *ngFor="let item of list"
        class="bazis-item"
        (click)="selectValue(item)"
    >
        <ng-template
            [ngTemplateOutlet]="itemTpl"
            [ngTemplateOutletContext]="{ item: item }"
        ></ng-template>
    </div>
</ng-container>
